import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import { selectOptionFactory } from '../../../../../../../../../utils';
import { LabeledSelect } from '../../../../../../../../generic';
import type { SelectOption } from '../../../../../../../../../types';
import type { SetProjectsFilter } from '../../../../types';

export const PROJECT_LAST_REVISION_WITHIN_OPTIONS_MAP: Record<string, SelectOption> = {
  anytime: selectOptionFactory('anytime', 'Anytime'),
  7: selectOptionFactory('7', 'Within 7 days'),
  30: selectOptionFactory('30', 'Within 30 days'),
  120: selectOptionFactory('120', 'Within 120 days'),
};

/**
 * convert the optional "lastRevisionWithin" number to a single SelectOption
 */
const determineSelectedOption = (lastRevisionWithin?: number): SelectOption => {
  if (!lastRevisionWithin) {
    return PROJECT_LAST_REVISION_WITHIN_OPTIONS_MAP.anytime as SelectOption;
  }

  return PROJECT_LAST_REVISION_WITHIN_OPTIONS_MAP[lastRevisionWithin.toString() || 'anytime'] as SelectOption;
};

/**
 * convert the selected SelectOption to the corresponding "lastRevisionWithin" number
 * where both undefined and 'anytime' are converted to undefined
 */
const mapSelectionToRevisionNumber = (selected: SelectOption | null): number | undefined => {
  if (!selected) {
    return undefined;
  }
  return selected.value === 'anytime' ? undefined : _.toNumber(selected.value);
};

type Props = {
  setFilters: SetProjectsFilter;
  lastRevisionWithin?: number;
};

const ProjectLastRevisionFilter: VoidFunctionComponent<Props> = ({ setFilters, lastRevisionWithin }) => {
  const handleLastRevisionChange = (selected: SelectOption | null) =>
    setFilters((prevFilters) => ({
      ...prevFilters,
      lastRevisionWithin: mapSelectionToRevisionNumber(selected),
    }));

  return (
    <LabeledSelect
      id="rgrevamp-last-revision-within-filter"
      label="Last revision"
      options={Object.values(PROJECT_LAST_REVISION_WITHIN_OPTIONS_MAP)}
      value={determineSelectedOption(lastRevisionWithin)}
      onChange={handleLastRevisionChange}
    />
  );
};

export default ProjectLastRevisionFilter;
